module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-1.jpg?v=a930553c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-1.jpg
 ** module id = 30
 ** module chunks = 1 2
 **/